<template>
  <div>
    <slot></slot>
    <AtomSnackbar />
  </div>
</template>
